/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography, Divider, Button, Popover } from "@mui/material";
import qs from "query-string";
import React, { useState, useEffect, useRef, useCallback } from "react";
import AddJob from "./AddJob.js";
import LoadingSpinner from "../../components/Composables/CircularProgressBar.js";
import CountInfo from "../../components/Composables/TilesCountInfo.js";
import API from "../../Utils/Interceptor/ApiMiddleware.js";
import DynamicDataGrid from "../../components/Composables/DynamicDataGrid.js";
import AddIcon from "@mui/icons-material/Add";
import formatters from "../../components/Composables/DataGridFormatters.js";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import DynamicForm from "../../components/Composables/DynamicForm.js";
import { debounce } from "lodash";
import { useNavigate, useLocation } from "react-router-dom";

function Jobs() {
  const [loading, setLoading] = useState({
    count: false,
    grid: false,
  });
  const debounceTimeout = useRef(null);
  const latestInputValue = useRef("");
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [jobsData, setJobsData] = useState({
    countData: [],
    listData: [],
    paginationModel: {
      pageSize: 25,
      page: 0,
    },
    showAllData: false,
  });
  const [openDialog, setOpenDialog] = useState({
    addJob: false,
    filter: false,
  });
  const [formConfigurations, setFormConfigurations] = useState([
    {
      label: "Job Title",
      type: "autocomplete-multiple",
      name: "jobTitle",
      options: [],
      text: "Job Title",
    },
    {
      label: "Company Name",
      type: "autocomplete-multiple",
      name: "companyName",
      options: [],
      text: "Company Name",
    },
    {
      label: "Branch Name",
      type: "autocomplete-multiple",
      name: "branchName",
      options: [],
      text: "Branch Name",
    },
    {
      label: "Status",
      type: "autocomplete-multiple",
      name: "status",
      options: [
        { value: "Active", label: "Active" },
        { value: "Closed", label: "Closed" },
        { value: "Cancelled", label: "Cancelled" },
        { value: "On Hold", label: "On Hold" },
        { value: "Full", label: "Full" },
      ],
      text: "Status",
    },
    {
      label: "Created By",
      type: "autocomplete-multiple",
      name: "enteredBy",
      options: [],
      text: "Created By",
    },
  ]);
  const [formState, setFormState] = useState({
    jobTitle: null,
    companyName: null,
    status: null,
    branchName: null,
    enteredBy: null,
  });
  const [appliedFilters, setAppliedFilters] = useState({
    jobTitle: null,
    companyName: null,
    status: null,
    branchName: null,
    enteredBy: null,
  });
  const [tempFormState, setTempFormState] = useState(formState);
  const handleChange = (key, value, inputValue = null) => {
    setTempFormState((prev) => ({
      ...prev,
      [key]: value,
      [`${key}Input`]: inputValue !== null ? inputValue : prev[`${key}Input`],
    }));

    if (inputValue !== null) {
      latestInputValue.current = inputValue;
      clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => {
        fetchJobsFilterData({ [`${key}Search`]: latestInputValue.current });
      }, 1000);
    }
  };
  const handleCloseAddJob = () => {
    setOpenDialog((prev) => ({ ...prev, addJob: false }));
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setTempFormState(formState);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const fetchJobsData = async () => {
    setLoading((prev) => ({
      ...prev,
      count: true,
    }));
    try {
      const response = await API.post("tiles/get-count", {
        tile_type: "job_count",
      });
      const apiData = response.data.data;

      setJobsData((prevState) => ({
        ...prevState,
        countData: apiData,
      }));
    } catch (error) {
      console.error("Error fetching jobs data:", error);
    } finally {
      setLoading((prev) => ({
        ...prev,
        count: false,
      }));
    }
  };
  useEffect(() => {
    const queryParams = qs.parse(location.search);

    const {
      page = 1,
      jobTitle,
      companyName,
      status,
      branchName,
      enteredBy,
    } = queryParams;

    const filtersFromQuery = {
      jobTitle: jobTitle
        ? Array.isArray(jobTitle)
          ? jobTitle
          : [jobTitle]
        : null,
      companyName: companyName
        ? Array.isArray(companyName)
          ? companyName
          : [companyName]
        : null,
      status: status ? (Array.isArray(status) ? status : [status]) : null,
      branchName: branchName
        ? Array.isArray(branchName)
          ? branchName
          : [branchName]
        : null,
      enteredBy: enteredBy
        ? Array.isArray(enteredBy)
          ? enteredBy
          : [enteredBy]
        : null,
    };

    setFormState(filtersFromQuery);
    setAppliedFilters(filtersFromQuery);

    setJobsData((prev) => ({
      ...prev,
      paginationModel: {
        ...prev.paginationModel,
        page: parseInt(page) - 1,
      },
    }));
  }, [location.search]);

  useEffect(() => {
    if (anchorEl) {
      const fieldsToFetch = formConfigurations
        .filter(
          (field) =>
            field.type === "autocomplete-multiple" &&
            !(
              field.options &&
              field.options.length > 0 &&
              field.options.every((opt) => opt.value && opt.label)
            )
        )
        .map((field) => field.name);

      const payload = {};

      fieldsToFetch.forEach((field) => {
        if (formState[field] !== null && formState[field] !== undefined) {
          payload[`${field}Search`] = "";
        }
      });

      if (Object.keys(payload).length > 0) {
        fetchJobsFilterData(payload);
      }
    }
  }, [anchorEl, formConfigurations]);

  const handleRowSelection = (row) => {
    navigate(`/jobs-description/${row.id}`, {
      state: {
        id: row.id,
      },
    });
  };
  const handleResetFilters = async () => {
    const resetFilters = {
      jobTitle: null,
      companyName: null,
      status: null,
      branchName: null,
      enteredBy: null,
    };
    setFormState(resetFilters);
    setJobsData((prevState) => ({
      ...prevState,
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    }));
    const query = qs.stringify(
      {
        ...resetFilters,
        page: 1,
      },
      { skipNull: true, skipEmptyString: true }
    );
    navigate(`/jobs?${query}`);

    handleClose();
  };
  const handleApplyFilters = () => {
    const query = qs.stringify(
      {
        ...tempFormState,
        page: 1,
      },
      { skipNull: true, skipEmptyString: true }
    );
    setFormState(tempFormState);
    setAppliedFilters(tempFormState);
    navigate(`/jobs?${query}`);
    // setAppliedFilters({ ...formState });
    // fetchJobsGridData();
    handleClose();
  };

  const fetchJobsFilterData = async (filterParams) => {
    try {
      const response = await API.get("/job/get-job-filter-details", {
        params: filterParams,
      });

      if (response) {
        const apiData = response.data.data;

        setFormConfigurations((prevConfig) =>
          prevConfig.map((config) => {
            if (apiData.length > 0 && apiData[0].hasOwnProperty(config.name)) {
              const newOptions = apiData
                .map((item) => item[config.name])
                .filter((val) => val && val.trim() !== "")
                .map((val) => ({
                  value: val,
                  label: val,
                }));

              const mergedOptions = [
                ...newOptions,
                ...(config.options || []),
              ].reduce((acc, option) => {
                if (!acc.find((o) => o.value === option.value)) {
                  acc.push(option);
                }
                return acc;
              }, []);

              return { ...config, options: mergedOptions };
            }
            return config;
          })
        );
      }
    } catch (error) {
      console.error("Error fetching filter data:", error);
    }
  };
  const stripId = (labelWithId) => {
    return labelWithId.replace(/\s\(\d+\)$/, "");
  };

  const debouncedFetchJobsFilterData = debounce(fetchJobsFilterData, 500);
  const fetchJobsGridData = useCallback(async () => {
    const payload = {
      filterJobTitle: appliedFilters.jobTitle
        ? appliedFilters.jobTitle.map(stripId)
        : null,
      filterEnteredBy: appliedFilters.enteredBy || null,
      filterStatus: appliedFilters.status || null,
      filterCompanyName: appliedFilters.companyName || null,
      filterBranchName: appliedFilters.branchName || null,
      rowLimit: jobsData.paginationModel.pageSize,
      page: jobsData.paginationModel.page + 1,
    };

    console.log(
      jobsData.paginationModel.page,
      jobsData.paginationModel.pageSize,
      appliedFilters,
      "jobsData.paginationModel.page"
    );
    setLoading((prev) => ({
      ...prev,
      grid: true,
    }));
    try {
      const response = await API.post("/job/get-all-jobs", payload);
      const apiData = response?.data?.data;
      setJobsData((prevState) => ({
        ...prevState,
        listData: apiData,
        showAllData: true,
      }));
      handleClose();
    } catch (error) {
      console.error("Error fetching Jobs grid data:", error);
    } finally {
      setLoading((prev) => ({
        ...prev,
        grid: false,
      }));
    }
  }, [
    appliedFilters.jobTitle,
    appliedFilters.enteredBy,
    appliedFilters.status,
    appliedFilters.companyName,
    appliedFilters.branchName,
    jobsData.paginationModel.page,
    jobsData.paginationModel.pageSize,
  ]);
  useEffect(() => {
    fetchJobsData();
  }, []);

  useEffect(() => {
    fetchJobsGridData();
  }, [fetchJobsGridData]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "16px",
        backgroundColor: "#E3F2FD",
        height: "100%",
        boxSizing: "border-box",
        borderRadius: "24px 0 0 0",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "16px",
          marginBottom: "16px",
          flexShrink: 0,
        }}
      >
        <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
          Jobs
        </Typography>

        {loading.count ? (
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "12px",
              flex: 1,
              textAlign: "center",
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100px",
            }}
          >
            <LoadingSpinner />
          </Box>
        ) : jobsData.countData.length > 0 ? (
          <CountInfo sections={jobsData.countData} showHeader={false} />
        ) : (
          <CountInfo sections={[]} showHeader={false} />
        )}
      </Box>
      <Box
        sx={{
          borderRadius: "12px",
          padding: "16px",
          backgroundColor: "white",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
            flexShrink: 0,
          }}
        >
          <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
            List of Jobs
          </Typography>

          <Box sx={{ display: "flex", gap: "12px" }}>
            <Button
              onClick={() =>
                setOpenDialog({
                  ...openDialog,
                  addJob: true,
                })
              }
              sx={{
                backgroundColor: "#2196F3",
                padding: "6px 10px",
                color: "white",
                display: "flex",
                alignItems: "center",
                borderRadius: "5px",
              }}
            >
              <AddIcon sx={{ fontSize: 20, marginRight: "8px" }} />
              <Typography sx={{ fontSize: "14px" }}>POST A JOB</Typography>
            </Button>

            {jobsData.showAllData && (
              <Button
                sx={{
                  backgroundColor: "#2196F3",
                  padding: "6px 10px",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "5px",
                }}
                onClick={(e) => handleOpen(e)}
              >
                <FilterAltOutlinedIcon
                  sx={{ fontSize: 20, marginRight: "8px" }}
                />
                <Typography sx={{ fontSize: "14px" }}>FILTER</Typography>
              </Button>
            )}
          </Box>
        </Box>
        <Box sx={{ flex: 1, overflow: "hidden" }}>
          <DynamicDataGrid
            rows={jobsData.listData.jobDetails || []}
            showCheckbox={false}
            onRowSelection={handleRowSelection}
            formatters={formatters}
            totalRows={jobsData?.listData?.totalJobs || 0}
            paginationModel={jobsData.paginationModel}
            buttonName="job"
            onPaginationModelChange={(paginationModel) => {
              setJobsData((prevState) => ({
                ...prevState,
                paginationModel: paginationModel,
              }));
              navigate(
                `/jobs?${qs.stringify(
                  {
                    ...formState,
                    page: paginationModel.page + 1,
                  },
                  { skipNull: true, skipEmptyString: true }
                )}`
              );
            }}
            setShowAllData={setJobsData}
            handleOpen={handleOpen}
            loading={loading.grid}
          />
        </Box>
      </Box>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ p: 2, width: 300 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Jobs Filters
          </Typography>
          <Divider sx={{ my: 1 }} />
          {formConfigurations ? (
            <DynamicForm
              formData={formConfigurations}
              formState={tempFormState}
              handleChange={handleChange}
              debouncedFilterData={debouncedFetchJobsFilterData}
              filterData={fetchJobsFilterData}
            />
          ) : (
            <LoadingSpinner />
          )}

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button onClick={handleResetFilters}>Reset</Button>
            <Button variant="contained" onClick={handleApplyFilters}>
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>

      <AddJob
        open={openDialog.addJob}
        closePopup={handleCloseAddJob}
        fetchJobsGridData={fetchJobsGridData}
      />
    </Box>
  );
}
export default Jobs;
